<script>
    import NauiSwitch from "../../naui/atoms/NauiSwitch.svelte";
    import NauiInput from "../../naui/atoms/NauiInput.svelte";
    import NauiCheckbox from "../../naui/atoms/NauiCheckbox.svelte";

    export let data = {};

</script>

<div class="grid-3-1 gap-1">
    <div>
        {#each data.embalajes as embalaje (embalaje.label)}
            <div class="box-l sx-ii mb-ii">
                <div class="min-w-300px">
                    <NauiCheckbox bind:value={embalaje.value} label="{embalaje.label}"/>
                </div>
                <div class="w-100">
                    <NauiInput bind:value="{embalaje.observaciones}" label="Observaciones"/>
                </div>
            </div>
        {/each}
    </div>
    <div>
        <div class="box-r sx-1">
            <div class="box-r min-w-200px">
                <p>¿Se requieren cajas?</p>
            </div>
            <NauiSwitch bind:active={data.requiereCajas.active} />
        </div>
        <div class="box-r">
            <NauiInput label="Cantidad" bind:value={data.requiereCajas.numero}/>
        </div>
    </div>
</div>

